import http from "@/settings/apiSettings"

class StariPosturiDataService {
    save(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post("/PER_StructsPosturiStari", data)
    }
}
export default new StariPosturiDataService()